import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Modal,
  Button,
  Alert,
  Spinner,
  Badge,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
import { Multiselect } from "multiselect-react-dropdown";
function Test() {
  var history = useHistory();
  //const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 25;
  const activePag = useRef(0);
  const [data, setData] = useState([]);
  const [delStatus, setDelStatus] = useState(false);
  const [allSubTests, setAllSubTests] = useState([]);
  const [allTest, setAllTest] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [testType, setTestType] = useState("amniocentesis");
  const [subTestId, setSubTestId] = useState([]);
  const [imageKey, setImageKey] = useState("");
  const [imageData, setImageData] = useState(null);
  const [testDesc, setTestDesc] = useState("");
  const [reportDesc, setReportDesc] = useState("");
  const [preInfo, setPreInfo] = useState("");
  const [image, setImage] = useState(null);
  const [testName, setTestName] = useState("");
  const [testPrice, setTestPrice] = useState("");
  const [offerPrice, setOfferPrice] = useState("");
  const [testID, setTestId] = useState("");
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [popular, setPopular] = useState(false);
  const [fasting, setFasting] = useState(false);
  const [labTest, setLabTest] = useState(false);
  const [featured, setFeatured] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [allSubTest, setAllSubTest] = useState([]);
  const [tubeType, setTubeType] = useState([]);

  const TypesObject = [
    "amniocentesis",
    "gastric fluid analysis",
    "kidney function test",
    "liver function test",
    "lumbar puncture",
    "malabsorption test",
    "thyroid function test",
    "urinalysis/uroscopy",
    "pregnancy test",
  ];
  const tubeTypeObject = ["Plain", "EDTA", "Fluride"];
  const [tubeObject, setTubeObject] = useState(tubeTypeObject);
  function getData() {
    axios.get(Baseurl.baseurl3 + "/health/get-all-health-test").then((res) => {
      console.log("dmdmdmdm", res.data.data);
      setSpinner(false);
      setAllTest(res.data.data);
      setSearchData(res.data.data);
      setData(document.querySelectorAll("#job_data tbody tr"));
    });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      if (val.Name.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setAllTest(filteredData);
  }
  const onChangePicture = (e) => {
    if (e.target.files[0].size / 1048576 < 3) {
      setImage(e.target.files[0]);
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImageData(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null);
    }
  };
  function addTest() {
    const data = new FormData();
    let testJson = {
      Name: testName,
      Description: testDesc,
      Price: testPrice,
      Type: testType,
      SubTest: subTestId === "" ? [] : subTestId,
      ReportDelivery: reportDesc,
      Fasting: fasting,
      Popular: popular,
      Featured: featured,
      IsNew: isNew,
      OfferPrice: offerPrice,
      TubeType: tubeType,
      LabTest: labTest,
    };
    data.append("data", JSON.stringify(testJson));
    data.append("image", image);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl3}/health/create-health-test`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setTestName("");
          setImage(null);
          setImageData(null);
          setTestDesc("");
          setReportDesc("");
          setPreInfo("");
          setTestType("amniocentesis");
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function updateTest() {
    let testFields = {
      name: testName,
      desc: testDesc,
      price: testPrice,
      type: testType,
      reportDesc: reportDesc,
      Fasting: fasting,
      oPrice: offerPrice,
      tubeType: tubeType,
      labTest: labTest,
    };
    axios
      .put(
        Baseurl.baseurl3 + `/health/update-health-test-info/${testID}`,
        testFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function addFields(val) {
    let testFields = [];
    if (val === "popular") {
      testFields = {
        popular: !popular,
      };
    }
    if (val === "feature") {
      testFields = {
        featured: !featured,
      };
    }
    if (val === "isnew") {
      testFields = {
        new: !isNew,
      };
    }
    axios
      .put(
        Baseurl.baseurl3 + `/health/update-health-test-${val}/${testID}`,
        testFields
      )
      .then((response) => {
        getData();
        // if (response.data.status) {
        //   swal("Added", response.data.message, "success", {
        //     button: "Done",
        //     timer: 1000,
        //   });
        // } else {
        //   swal("Oops", response.data.message, "error", {
        //     button: "Done",
        //     timer: 1000,
        //   });
        // }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function updateTestImage() {
    const data = new FormData();
    data.append("image", image);
    data.append("testImageKey", imageKey);

    var config = {
      method: "put",
      url: `${Baseurl.baseurl3}/health/update-health-test-image/${testID}`,
      data: data,
    };
    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();

          swal("Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function deleteTests() {
    axios
      .delete(Baseurl.baseurl3 + `/health/delete-health-test-by-id/${testID}`)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }
  function addTestFunction() {
    setShow(true);
    setUpdateStatus(false);
    setTestName("");
    setTestDesc("");
    setTestPrice("");
    setReportDesc("");
    setTestType("amniocentesis");
    setPreInfo("");
    setImageData(null);
    getAllSubTest();
    setOfferPrice("");
    setPopular(false);
    setFeatured(false);
    setIsNew(false);
    setFasting(false);
    setLabTest(false)
  }
  function getAllSubTest(value) {
    axios.get(Baseurl.baseurl3 + "/health/get-all-sub-test").then((res) => {
      if (value) {
        let filterArray = res.data.subTest;
        filterArray = filterArray.filter(function (obj) {
          return !this.has(obj._id);
        }, new Set(value.map((obj) => obj._id)));
        setAllSubTest(filterArray);
      } else {
        setAllSubTest(res.data.subTest);
      }
    });
  }
  const selection1 = (selectedValues) => {
    console.log("selected", selectedValues);
    let id = [];
    selectedValues.map((val) => {
      id.push(val._id);
    });
    setSubTestId(id);
  };
  const selection2 = (selectedValues) => {
    console.log("selected", selectedValues);
    setTubeType(selectedValues);
  };
  function updateFunction(val) {
    setShow(true);
    setUpdateStatus(true);
    setTestName(val.Name);
    setTestDesc(val.Description);
    setTestPrice(val.Price);
    setReportDesc(val.ReportDelivery);
    setTestType(val.Type);
    setPreInfo(val.PreInfo);
    setImageData(val.Image);
    setTestId(val._id);
    setPopular(val.Popular);
    setFeatured(val.Featured);
    setIsNew(val.IsNew);
    setImageKey(val.ImageKey);
    setOfferPrice(val.OfferPrice);
    getAllSubTest(val.SubTest);
    setLabTest(val.LabTest);
    setFasting(val.Fasting);
    console.log("tube tyoe", val.TubeType);
  }
  function removeSubTests(val, test) {
    let testFields = {
      subTestID: val,
    };
    axios
      .put(
        Baseurl.baseurl3 + `/health/remove-subtest-from-health-test/${test}`,
        testFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function addSubTestToPackage() {
    let testArray = {
      subTestID: subTestId,
    };
    axios
      .put(
        Baseurl.baseurl3 + `/health/add-subtest-to-health-test/${testID}`,
        testArray
      )
      .then((response) => {
        if (response.data.status) {
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
          setSubTestId([]);
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        handleClose();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function JSONToCSV(data) {
    const keys = Object.keys(data[0]);
    const csvData = [keys.join(",")];
  
    for (let item of data) {
      const values = keys.map((key) => {
        const value = item[key];
        return value !== undefined ? `"${String(value).replace(/"/g, '""')}"` : "";
      });
      csvData.push(values.join(","));
    }
  
    return csvData.join("\n");
  }
  function downloadBulk(exportJson) {
    console.log("donwload data", exportJson);
    const csvContent = "data:text/csv;charset=utf-8," + JSONToCSV(exportJson);
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `tests.csv`);
    link.click();
  }
  const ReadMore = ({ children }) => {
      const [isReadMore, setIsReadMore] = useState(true);
  
      return (
        <>
          {isReadMore ? children && children.slice(0, 120) : children}
          <span
            onClick={() => {
              setIsReadMore(!isReadMore);
            }}
          >
            {isReadMore ? (
              <b style={{color:"#b30000"}}>{" "}Readmore</b>
            ) : (
              <b style={{color:"#b30000"}}>{" "}Readless</b>
            )}
          </span>
        </>
      );
    };
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        {delStatus && (
          <Modal.Header closeButton>
            <Modal.Title>Delete Test</Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body>
          {delStatus ? (
            <h4>Are You Sure You Want to Delete This Test ?</h4>
          ) : (
            <>
              {allSubTests.length === 0 && (
                <h4 className="text-center">No Test Added</h4>
              )}
              {allSubTests.map((test) => {
                return (
                  <div className="row">
                    <div className="col-sm-8 mt-3">
                      <strong>{test.Name}</strong>
                    </div>
                    <div className="col-sm-2 mt-3">
                      <Link
                        onClick={() => {
                          removeSubTests(test._id, testID);
                        }}
                        href="#"
                        className="btn btn-danger shadow btn-xs sharp"
                      >
                        <i className="fa fa-trash"></i>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </Modal.Body>
        {delStatus && (
          <Modal.Footer>
            <button
              onClick={() => {
                deleteTests();
              }}
              className="btn btn-primary"
            >
              Delete
            </button>
          </Modal.Footer>
        )}
      </Modal>
      <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Test ({testID})</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "18px" }}>
          <div>
            <div className="row">
              <div className="col-sm-4">
                <label>
                  Test Name <span className="text-danger">*</span>
                </label>
                <input
                  value={testName}
                  type="text"
                  className="form-control"
                  placeholder="enter test Name"
                  onChange={(e) => setTestName(e.target.value)}
                  required
                />
              </div>

              <div className="col-sm-4">
                <label>
                  Test Description<span className="text-danger">*</span>
                </label>
                <textarea
                  value={testDesc}
                  type="text"
                  className="form-control"
                  placeholder="enter Description"
                  onChange={(e) => setTestDesc(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-4">
                <label>
                  Report Description<span className="text-danger">*</span>
                </label>
                <textarea
                  value={reportDesc}
                  type="text"
                  className="form-control"
                  placeholder="enter Description"
                  onChange={(e) => setReportDesc(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-4 ">
                <label>
                  Sample Type <span className="text-danger">*</span>
                </label>
                <select
                  className="col-sm-12 text-primary p-2 custom-select"
                  id="val-skill"
                  name="val-skill"
                  placeholder="Select Search Item"
                  defaultValue={testType}
                  onChange={(event) => {
                    setTestType(event.target.value);
                  }}
                >
                  {TypesObject &&
                    TypesObject.map((val) => (
                      <option value={val}>{val}</option>
                    ))}
                </select>
              </div>
              <div className="col-sm-4">
                <label>
                  Test Price (₹) <span className="text-danger">*</span>
                </label>
                <input
                  value={testPrice}
                  type="number"
                  className="form-control"
                  placeholder="enter test Price"
                  onChange={(e) => setTestPrice(e.target.value)}
                  required
                />
              </div>
              <div className="col-sm-4">
                <label>
                  Offer Price (₹) <span className="text-danger">*</span>
                </label>
                <input
                  value={offerPrice}
                  type="number"
                  className="form-control"
                  placeholder="enter offer Price"
                  onChange={(e) => setOfferPrice(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-4 ">
                <label>
                  Tube Type <span className="text-danger">*</span>
                </label>
                <input
                  value={tubeType}
                  type="text"
                  className="form-control"
                  placeholder="enter tube type"
                  onChange={(e) => setTubeType(e.target.value)}
                  required
                />
              </div>
              <div className={`col-sm-${updateStatus ? "3" : "4"}`}>
                <label>
                  Sub Test <span className="text-danger">*</span>
                </label>
                <Multiselect
                  options={allSubTest}
                  displayValue="Name"
                  onSelect={selection1}
                />
              </div>
              {updateStatus && (
                <div className="col-sm-1 mt-4">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      addSubTestToPackage();
                    }}
                  >
                    Add
                  </button>
                </div>
              )}

              <div className={`col-sm-${updateStatus ? "3" : "4"}`}>
                <label htmlFor="val-range">
                  Test Image
                  <span className="text-danger">*</span>
                </label>
                <div className="register_profile_image mt-2">
                  <input
                    id="profilePic"
                    type="file"
                    onChange={(e) => {
                      onChangePicture(e);
                    }}
                  />
                </div>
                {imageData && (
                  <div
                    style={{
                      marginTop: "5px",
                      width: 180,
                      height: 100,
                      aspectRatio: 1 * 1.4,
                    }}
                    className="previewProfilePic"
                  >
                    <img
                      alt=""
                      className="playerProfilePic_home_tile"
                      style={{
                        resizeMode: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      src={imageData}
                    />
                  </div>
                )}
              </div>

              {updateStatus && (
                <div className="col-sm-1 mt-5 p-0">
                  <button
                    onClick={() => {
                      updateTestImage();
                    }}
                    className="btn btn-primary mt-3"
                  >
                    Change
                  </button>
                </div>
              )}
            </div>
            <div className="row mt-3">
              <div className="col-sm-1 mt-2">
                <label>Popular</label>
              </div>
              <div className="col-sm-1 mt-1">
                <Switch
                  onChange={() => {
                    setPopular(!popular);
                    if (updateStatus) {
                      addFields("popular");
                    }
                  }}
                  checked={popular}
                />
              </div>
              <div className="col-sm-1 mt-2">
                <label>Featured</label>
              </div>
              <div className="col-sm-1 mt-1">
                <Switch
                  onChange={() => {
                    setFeatured(!featured);
                    if (updateStatus) {
                      addFields("feature");
                    }
                  }}
                  checked={featured}
                />
              </div>
              <div className="col-sm-1 mt-2">
                <label>New</label>
              </div>
              <div className="col-sm-1">
                <Switch
                  onChange={() => {
                    setIsNew(!isNew);
                    if (updateStatus) {
                      addFields("isnew");
                    }
                  }}
                  checked={isNew}
                />
              </div>
              <div className="col-sm-1 mt-2">
                <label>
                  Fasting<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-1">
                <Switch
                  onChange={() => {
                    setFasting(!fasting);
                  }}
                  checked={fasting}
                />
              </div>
              <div className="mt-2">
                <label>Lab Test</label>
              </div>
              <div className="col-sm-1">
                <Switch
                  onChange={() => {
                    setLabTest(!labTest);
                  }}
                  checked={labTest}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? (
            <button
              className="btn btn-primary"
              onClick={() => {
                updateTest();
              }}
            >
              Update
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                addTest();
              }}
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background: "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div
            style={{ marginTop: 0 }}
            className="btn btn-secondary"
            onClick={() => {
              let downloadData = [];
              allTest.map((val) => {
                downloadData.push({
                  TestName: val.Name || "",
                  TestDescription: val.Description || "",
                  Price: val.Price || "",
                  OfferPrice: val.OfferPrice || "",
                  ReportDelivery: val.ReportDelivery || "",
                  Fasting: val.Fasting ? "Yes" : "No",
                  Featured: val.Featured ? "Yes" : "No",
                  New: val.IsNew ? "Yes" : "No",
                  LabTest: val.LabTest ? "Yes" : "No",
                  Popular: val.Popular ? "Yes" : "No",
                  TubeType: Array.isArray(val.TubeType) ? val.TubeType.join(", ") : "",
                  SubTest: Array.isArray(val.SubTest) ? val.SubTest.map((item) => item.Name).join(", ") : "",
                });
              });
              downloadBulk(downloadData);
            }}
          >
            Download
          </div>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          <button
            onClick={() => {
              addTestFunction();
            }}
            className="btn btn-primary"
          >
            Add Test
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>Image</strong>
                    </th>
                    <th>
                      <strong>Name</strong>
                    </th>
                    <th>
                      <strong>Price</strong>
                    </th>
                    <th>
                      <strong>OfferPrice</strong>
                    </th>
                    {/* <th>
                      <strong>SubTest</strong>
                    </th> */}
                    <th>
                      <strong>Description</strong>
                    </th>
                    {/* <th>
                      <strong>Description</strong>
                    </th> */}
                    <th>
                      <strong>Report</strong>
                    </th>
                    <th>
                      <strong>Type</strong>
                    </th>

                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: "13px" }}>
                  {allTest &&
                    allTest.map((val, key) => (
                      <tr key={val.id}>
                        <td>
                          <div className="profile-photo">
                            <img
                              src={val.Image}
                              height={50}
                              width={50}
                              alt="profile"
                            />
                          </div>
                        </td>
                        <td>{val.Name}</td>
                        <td>₹ {val.Price}</td>
                        <td>₹ {val.OfferPrice}</td>
                        {/* <td className="col-sm-12">
                          {val.SubTest.map((test) => {
                            return (
                              <div className="row">
                                <div className="col-sm-8 mt-3">
                                  <strong>{test.Name}</strong>
                                </div>
                                <div className="col-sm-2 mt-3">
                                  <Link
                                    onClick={() => {
                                      removeSubTests(test._id, val._id);
                                    }}
                                    href="#"
                                    className="btn btn-danger shadow btn-xs sharp"
                                  >
                                    <i className="fa fa-trash"></i>
                                  </Link>
                                </div>
                              </div>
                            );
                          })}
                        </td> */}
                        
                        <td>{val.Description.length>119?<ReadMore>{val.Description}</ReadMore>:val.Description}</td>
                        <td>{val.ReportDelivery}</td>
                        <td>{val.Type}</td>

                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  updateFunction(val);
                                }}
                              >
                                Update
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setTestId(val._id);
                                  setShow1(true);
                                  setDelStatus(false);
                                  setAllSubTests(val.SubTest);
                                }}
                              >
                                View Tests
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setTestId(val._id);
                                  setShow1(true);
                                  setDelStatus(true);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allTest && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allTest
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default Test;
